export default {
  quickView: {
    en: 'Quick view',
  },
}
